import React from 'react';

import DsGenericErrorScreen from 'screens/DS/GenericError';

const GenericError = () => {
  return <DsGenericErrorScreen />;
};

export default GenericError;
